import styled from '@emotion/styled';
import { Variables } from '../../../base';

export const FilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 320px;
    max-width: 320px;
`;

export const FilterSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
`;

export const SectionLabel = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: ${Variables.Colors.n85};
    text-transform: uppercase;
    letter-spacing: 0.3px;
`;

export const FilterRow = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Divider = styled.div`
    height: 1px;
    background-color: ${Variables.Colors.n15};
    margin: 16px 0;
`;

export const ClearButton = styled.button`
    background: transparent;
    border: none;
    color: ${Variables.Colors.b300};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
    transition: color 0.2s;

    &:hover {
        color: ${Variables.Colors.b400};
    }

    &:active {
        color: ${Variables.Colors.b500};
    }
`;

